import { useCartStore } from "~/store/cart"
import { useCookie, useNuxtApp } from "#app"
import { CART_ITEMS_COOKIE_NAME } from "~/utils/userUtils"
import { cookieOptions } from "~/utils/cookieUtils"

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!process.server) return

  const nuxtApp = useNuxtApp()
  const cartStore = useCartStore(nuxtApp.$pinia)

  const cartItemsCookie = useCookie(CART_ITEMS_COOKIE_NAME, cookieOptions)

  if (cartItemsCookie.value?.length > 0) {
    await cartStore.loadCartItems(cartItemsCookie.value)
  }
})
